/**
 * Routes skill-up.
 *
 * @remarks
 * - `/skill-up` → home (liste des sessions disponibles)
 * - `/skill-up/sessions/:sessionKey` → vue d'une session active
 * - `/skill-up/competences` → arbre de compétences personnel (SAAS-356)
 *
 * Le shell n'importe PAS ce fichier directement — les routes sont agrégées via
 * `manifest.routes[]` (cf. `src/app/router/routes.tsx` factory).
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const skillUpRoutes: RouteObject[] = [
  {
    path: 'skill-up',
    Component: Outlet,
    handle: { context: CONTEXTS.SKILL_UP_HOME, title: 'Skill-up' },
  },
  {
    path: 'skill-up/sessions/:sessionKey',
    Component: Outlet,
    handle: { context: CONTEXTS.SKILL_UP_SESSION, title: 'Session skill-up' },
  },
  {
    path: 'skill-up/competences',
    Component: Outlet,
    handle: { context: CONTEXTS.SKILL_UP_COMPETENCES, title: 'Arbre de compétences' },
  },
];
